module.exports = __webpack_public_path__ + "static/media/warpath_screen_3.470000e0.jpg";